import React, { useState, useContext, createContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import PAblue from "./PAblue";

import { XBEmain } from "./XBEmain";
import { getData } from "./airtable";
import { XBEcard } from "./XBEcard";
import { Integration } from "./integration/Integration";
import { AdminSwitcher } from './integration/AdminSwitcher';
import { CardEmail } from './integration/CardEmail';

import {IntlProvider} from 'react-intl';
import { CardLanding } from './integration/CardLanding';
import { CardOnePager } from './integration/CardOnePager';

export const XbeContext = createContext();

export function CardsPage() {
  const [language, setLanguage] = useState("en");

  const [salesCards, setSalesCards] = useState([]);
  const [tags, setTags] = useState([]);
  const [cards, setCards] = useState([]);

  const airtableUrl = "https://api.airtable.com/v0/appdCxvaFQFduybvv";
  const readonlyAPIKEY = "keyprC3qGqfVaAomq";

  // ADMIN
  const [editId, setEditId] = useState();

  const [installId, setInstallId] = useState();



  const [paCookie, setPaCookie] = useState();





  useEffect(() => {
    if (!salesCards.length) {
      fetch(
        `${airtableUrl}/salescards?api_key=${readonlyAPIKEY}&sort%5B0%5D%5Bfield%5D=importance&sort%5B0%5D%5Bdirection%5D=desc`
      )
        .then((resp) => resp.json())
        .then((response) => {
          console.log("response.records = ", response.records);
          setSalesCards([...response.records]);
        })
        .catch((err) => {
          // Error :(
        });
    }
  }, [salesCards]);

  useEffect(() => {
    if (!tags.length) {
      fetch(`${airtableUrl}/tags?api_key=${readonlyAPIKEY}`)
        .then((resp) => resp.json())
        .then((response) => {
          console.log("response.records = ", response.records);
          setTags([...response.records]);
        })
        .catch((err) => {
          // Error :(
        });
    }
  }, [tags]);

  useEffect(() => {
    if (tags && salesCards) {
      let plainCards = salesCards.map((oneCard) => ({
        tags: [
          ...(oneCard["fields"]["stage"]
            ? oneCard["fields"]["stage"].map((o) => getData(tags, o, "id"))
            : null),
          ...(oneCard["fields"]["monetization"]
            ? oneCard["fields"]["monetization"].map((o) =>
                getData(tags, o, "id")
              )
            : null),
          ...(oneCard["fields"]["platform"]
            ? oneCard["fields"]["platform"].map((o) => getData(tags, o, "id"))
            : null),
        ],
        ...oneCard["fields"],
      }));
      console.log("plainCards = ", plainCards);
      setCards(plainCards);
    }
  }, [tags, salesCards]);

  const [filters, setFilters] = useState([
    "pre_launch",
    "early_access",
    "live_game",
    "microtransactions",
    "premium",
    "subscriptions",
    "pc_mac",
    "web",
    "console",
    "mobile",
  ]);

  return (
    <XbeContext.Provider
      value={{
        language: language,
        setLanguage: setLanguage,
        salesCards: salesCards,
        tags: tags,
        cards: cards,

        filters: filters,
        setFilters: setFilters,

        editId: editId,
        setEditId: setEditId,

        installId: installId,
        setInstallId: setInstallId,

        paCookie: paCookie,
        setPaCookie: setPaCookie,
      }}
    >
      <XBEroutes />
    </XbeContext.Provider>
  );
}

export const XBEroutes = () => {
  const context = useContext(XbeContext);

  const getCardData = (cardId) => {
    console.log("cards = ", context["cards"]);

    let ret = context["cards"].filter(
      (one) => one["salesCardId"] === cardId
    )[0];

    return ret;
  };

  return (
    <Router>
      <Switch>
        <Route
          exact path={["/cms/site"]}
          render={(props) => {
            return (
              <React.Fragment>
                <XBEmain cms="site" />
              </React.Fragment>
            );
          }}>
        </Route>

        <Route
          exact path={["/cms/site_ru"]}
          render={({ history }) => {
            context["setLanguage"]("ru");
            history.push("/cms/site");
            return null;
          }}>
        </Route>

        <Route
          exact path={["/cms", "/cms/all", "/cms/all/:cardId"]}
          render={({match}) => {
          return (
          <React.Fragment>
            <XBEmain
              cms="all"
              // cardId={match.params.cardId}
            />
          </React.Fragment>
           );
          }}>
        </Route>

        <Route
          exact path={["/cms/pa"]}
          render={(props) => {
            return (
              <React.Fragment>
                <XBEmain cms="pa" />
              </React.Fragment>
            );
          }}>
        </Route>

        <Route
          exact path={["/cms/mobile"]}
          render={(props) => {
            return (
              <React.Fragment>
                <XBEmain cms="mobile" />
              </React.Fragment>
            );
          }}>
        </Route>

        <Route
          exact path={["/card/:cardId"]}
          render={(props) => {
            console.log("props = ", props["location"]["search"]);
            // debugger

            return (
              <React.Fragment>

                <AdminSwitcher
                  active='integration'
                  cardId={props["match"]["params"]["cardId"]}
                />

                <Integration
                  step={1}
                  tags={context["tags"]}
                  filters={context["filters"]}
                  salesCardId={props["match"]["params"]["cardId"]}
                  {...getCardData(props["match"]["params"]["cardId"])}
                  step={
                    props["location"]["search"]
                      ? props["location"]["search"]
                          .split("?")[1]
                          .split("step=")[1]
                          .split("&")[0]
                      : false
                  }
                />
              </React.Fragment>
            );
          }}>
        </Route>

        <Route
          exact path={["/card-email/:cardId"]}
          render={(props) => {
            console.log("props = ", props["location"]["search"]);
            // debugger

            return (
              <React.Fragment>

                <AdminSwitcher
                  active='email'
                  cardId={props["match"]["params"]["cardId"]}
                />

                <CardEmail
                  step={1}
                  tags={context["tags"]}
                  filters={context["filters"]}
                  salesCardId={props["match"]["params"]["cardId"]}
                  {...getCardData(props["match"]["params"]["cardId"])}
                  step={
                    props["location"]["search"]
                      ? props["location"]["search"]
                          .split("?")[1]
                          .split("step=")[1]
                          .split("&")[0]
                      : false
                  }
                />
              </React.Fragment>
            );
          }}
          >
        </Route>


        <Route
          exact path={["/card-onepager/:cardId"]}
          render={(props) => {
            console.log("props = ", props["location"]["search"]);
            // debugger

            return (
              <React.Fragment>

                <AdminSwitcher
                  active='opepager'
                  cardId={props["match"]["params"]["cardId"]}
                />

                <CardOnePager
                  step={1}
                  tags={context["tags"]}
                  filters={context["filters"]}
                  salesCardId={props["match"]["params"]["cardId"]}
                  {...getCardData(props["match"]["params"]["cardId"])}
                  step={
                    props["location"]["search"]
                      ? props["location"]["search"]
                          .split("?")[1]
                          .split("step=")[1]
                          .split("&")[0]
                      : false
                  }
                />
              </React.Fragment>
            );
          }}/>


        <Route
          exact path={["/card-landing/:cardId"]}
          render={(props) => {
            console.log("props = ", props["location"]["search"]);
            // debugger

            return (

              <React.Fragment>

                <AdminSwitcher
                  active='landing'
                  cardId={props["match"]["params"]["cardId"]}
                />

                <CardLanding
                  step={1}
                  tags={context["tags"]}
                  filters={context["filters"]}
                  salesCardId={props["match"]["params"]["cardId"]}
                  {...getCardData(props["match"]["params"]["cardId"])}
                  step={
                    props["location"]["search"]
                      ? props["location"]["search"]
                          .split("?")[1]
                          .split("step=")[1]
                          .split("&")[0]
                      : false
                  }
                />
              </React.Fragment>
            );
          }}>
        </Route>


        <Route
          exact path="/"
           render={(props) => {
            // let f = props['location']['search'].split('filters=')[1] ? props['location']['search'].split('filters=')[1].split(',') : null;
            // if (f && (f.length !== context['filters'].length)) context['setFilters'](f)
            return (
              <React.Fragment>
                <XBEmain
                  cms="all"
                  // cardId={match.params.cardId}
                />
              </React.Fragment>
            );
          }}>
        </Route>
      </Switch>
    </Router>

  );
};
